import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_3 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.3 Case 3</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_3"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 3. This is a positive case. You
                may notice that there is image noise and, along with the
                patient’s positioning, this may make it more challenging to
                interpret this case. Beginning in the occipital regions seen
                here, white matter tracts are not delineated. Increased activity
                is seen in the gray matter resulting in loss of gray-white
                contrast.
              </p>
              <p>
                As we continue moving superiorly, and entering into the temporal
                regions identified here, there is cortical thinning seen on the
                left and the right. This can be confirmed by utilizing the
                accompanying fused PET/CT images, which show this to be true
                bilaterally. Returning to the PET images once again, white
                matter tracts are not delineated on the left or on the
                right-hand side, and there is loss of gray-white contrast
                bilaterally.
              </p>
              <p>
                In addition, the accompanying coronal image may also be used to
                evaluate the extent of the gray matter in the cortex. Increased
                activity is seen extending to the cortical rim, as can be seen
                here.
              </p>
              <p>
                As we enter into the frontal and parietal cortices, identified
                here, white matter tracts are not delineated on the left or on
                the right-hand side. Increased activity is seen within the gray
                matter, and there is loss of gray-white contrast bilaterally. In
                the remainder of the slices, this continues to be true.
              </p>
              <p>
                This case is positive, even with the presence of image noise and
                atrophy, as there is loss of gray-white contrast in multiple
                regions. If you called this case negative, you may want to
                review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-2"
          nextLesson="/module-4/module-4-1-4"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1226351714&entry_id=1_bjbacaf4&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_bjbacaf4"
        />
      </main>
    </div>
  );
};

export default Module_4_1_3;
